import { useTranslation } from 'react-i18next';
import { 
  DialogFooter 
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import Text from '@/components/atoms/Text/Text';

interface ModalFooterProps {
  onClose: () => void;
}

const ModalFooter: React.FC<ModalFooterProps> = ({ onClose }) => {
  const { t } = useTranslation();
  
  return (
    <DialogFooter className="border-t bg-muted/30 p-4 sm:p-6">
      <div className="flex flex-col sm:flex-row justify-between items-center w-full gap-3 sm:gap-0">
        <Text variant="small" className="text-center sm:text-left">{t('termsAndPrivacyModal.copyright')}</Text>
        <Button variant="outline" onClick={onClose} className="rounded-2xl w-full sm:w-auto">
          {t('termsAndPrivacyModal.closeButton')}
        </Button>
      </div>
    </DialogFooter>
  );
};

export default ModalFooter;